import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
  selector: 'ark-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss']
})
export class AlertModalComponent implements OnInit {

  @Input() label: string;
  @Input() option: any;
  @Output() closeClick = new EventEmitter<any>();
  @Output() click = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
    if(!this.option) {
      this.option = {
        btnOk: 'Ok',
        btnCancel: 'Close',
      }
    } 

  }

  
  onClickButton(event) {
    this.closeClick.emit(event);
  }

  onClick(event) {
    this.click.emit(event);
  }

}
